import {useGetSetting} from '../../../../core/use-get-setting';
import {useUpdateSetting} from '../../../../core/use-update-setting';

export const useShowGetStarted = (): {
    shouldShowGetStarted: boolean | null | undefined;
    onHideGetStarted: () => Promise<any> | null | undefined;
    isLoading: boolean;
} => {
    const {setting, isLoading} = useGetSetting({
        settingName: 'hide_competitor_iq_get_started',
    });
    const updateSetting = useUpdateSetting();

    const onHideGetStarted = () =>
        updateSetting({
            settingName: 'hide_competitor_iq_get_started',
            isGlobal: true,
            value: '1',
        });

    return {
        shouldShowGetStarted: !setting || setting.value !== '1',
        isLoading,
        onHideGetStarted,
    };
};
